/**
 * dom.js — 跨檔共用的 DOM / 字串小工具（B-10 util 重構收斂）
 *
 * 收斂全站重複的 inline 實作：
 *   - prefersReducedMotion()：原散落 11 處 `function prefersReducedMotion()` +
 *     3 檔（4 處）`const prefersReducedMotion = window.matchMedia(...).matches`。
 *   - escapeHtml(s)：原散落 4 處 verbatim 同式的 `String(s).replace(/[&<>"']/g, map)`。
 *
 * 兩函式行為與原 inline 版逐字等義（見各遷移點），純去重、零語義變更。
 */

/**
 * 使用者是否偏好減少動態效果（prefers-reduced-motion: reduce）。
 *
 * 每次呼叫即時讀取 media query（live），與原 11 處 `function` 版逐字等義。
 * 原 4 處 `const prefersReducedMotion = window.matchMedia(...).matches`（讀一次的布林）
 * 改為在原地以本函式取值（`const prefersReducedMotion = prm()`，import 別名）保留「讀一次」
 * 語義，故 timing 不變。
 *
 * @returns {boolean}
 */
export function prefersReducedMotion() {
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

/**
 * HTML 字串跳脫（防 XSS）—— 插入 innerHTML 模板前對所有外來值跳脫。
 *
 * 與原 render-cards.js / admin-table.js / admin-editor.js / field-factory.js 四處
 * verbatim 同式逐字等義：String(s).replace(/[&<>"']/g, map)。
 *
 * @param {*} s 任意值（非字串會先 String() 轉換，與原版一致）
 * @returns {string}
 */
export const escapeHtml = (s) => String(s).replace(/[&<>"']/g, (c) => ({
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
}[c]));
